var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.76775C3 5.29535 4.21946 6.53337 5.72273 6.53337H9.43237V2.7653C9.43237 1.2377 8.21387 0 6.71028 0C4.66119 0 3 1.68703 3 3.76775ZM3.21558 7.93115C3.2758 7.92595 3.33634 7.92334 3.39752 7.92334H9.54V20H6.32942C4.74255 20 3.43275 18.7945 3.23992 17.2357V12.0773C3.23456 12.0773 3.22906 12.077 3.2236 12.0767H3.22359L3.22352 12.0767L3.21558 12.0763V7.93115ZM11.5302 20V7.92334H17.5836C17.6755 7.92334 17.7662 7.92953 17.8549 7.94156V12.0607L17.8483 12.0616L17.8437 12.0623V16.8423C17.8437 18.5863 16.4516 20 14.7346 20H11.5302ZM11.5676 6.53305V2.7653C11.5676 1.2377 12.7874 0 14.2904 0C16.3391 0 18 1.68703 18 3.76808C18 5.29568 16.7815 6.53337 15.2779 6.53337H11.5683L11.5676 6.53305Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishesIcon);
export default __webpack_public_path__ + "static/media/wishes-icon.15c3a2deb99d1dd43e84afa08bcd8bab.svg";
export { ForwardRef as ReactComponent };